// DO NOT REMOVE A FLAG UNTIL QUERIES THAT NO LONGER USE THE FLAG IS RELEASED TO PROD
export enum FeatureFlagKey {
  PlaceHolder = 'placeHolder',
  AddADog2025 = 'ev_app_add_a_dog_flow_2025',
  MyevSignInAndUpRedirect2025 = 'myev_sign_in_and_up_redirect_2025',
  Surveys2025 = 'surveys_2025',
}

// DO NOT REMOVE A DEFAULT VALUE UNTIL CODE THAT NO LONGER USES THE FLAG IS RELEASED TO PROD
export const featureFlagKeyToDefaultValueMap: Record<FeatureFlagKey, boolean> = {
  [FeatureFlagKey.PlaceHolder]: false,
  [FeatureFlagKey.AddADog2025]: false,
  [FeatureFlagKey.MyevSignInAndUpRedirect2025]: false,
  [FeatureFlagKey.Surveys2025]: false,
};
